module.exports = __webpack_public_path__ + "static/media/step1-poster.c3baec1f.png";